import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { CartProvider } from './hooks/useCart';
import { ToastProvider } from './hooks/useToast';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Composant interne qui utilise useLocation (doit être à l'intérieur du BrowserRouter)
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Scroll fluide
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <ToastProvider>
        <CartProvider>
          <AppRoutes />
        </CartProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;